import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import Loading from '../components/loading';
import Dialog from '../components/dialog/base';
import NavMenu from '../components/navMenu';

import Routes from '../routes';
import { useAuth } from '../utils/auth';
import { useDialog } from '../utils/dialog';

const App = () => {
  const auth = useAuth();
  const dialog = useDialog();
  const history = useHistory();

  const [shouldPageUpdated, setShouldPageUpdated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const loadingCounter = useSelector((state) => state.loading.counter);
  const meta = useSelector((state) => state.meta.data);

  const logout = () => {
    auth.signout({ resetLocalStorage: true });
    history.replace('/');
  };

  const onToggle = () => {
    setShouldPageUpdated(true);
  };

  useEffect(() => {
    setIsLoading(loadingCounter > 0);
  }, [loadingCounter]);

  useEffect(() => {
    if (shouldPageUpdated) setShouldPageUpdated(false);
  }, [shouldPageUpdated]);

  if (dialog.data.message && dialog.data.message.includes('\n')) {
    dialog.data.message = dialog.data.message.split('\n');
  }

  return (
    <>
      <NavMenu
        show={!(meta && meta.hideMenu)}
        title={meta && meta.title}
        onLogout={() =>
          dialog.openConfirm({
            message: '確定要登出嗎？',
            cancelColor: 'error',
            confirmText: '登出',
            onConfirm: logout,
          })
        }
        onToggle={() => onToggle()}
      >
        <Routes shouldPageUpdated={shouldPageUpdated} />
      </NavMenu>

      <Dialog
        open={dialog.isOpen}
        title={dialog.data.title}
        cancelText={dialog.data.cancelText}
        cancelColor={dialog.data.cancelColor}
        confirmColor={dialog.data.confirmColor}
        onClose={() => dialog.close()}
        onCancel={() => dialog.cancel()}
        onConfirm={() => dialog.confirm()}
        isConfirm={dialog.data.isConfirm}
      >
        {Array.isArray(dialog.data.message) ? (
          <ul>
            {dialog.data.message.map(function (message, index) {
              return <li key={index}>{message}</li>;
            })}
          </ul>
        ) : (
          dialog.data.message
        )}
      </Dialog>

      <Loading show={isLoading} />
    </>
  );
};

export default App;
